<template>
  <div class="row mx-3 px-md-5 pt-3 pb-5 mb-5 justify-content-center">
    <div class="col-12 text-center mt-3" v-if="mostrar_tiempo_restante">
        {{tiempo_restante_horas}}
      </div>
    <div class="col-12 mt-3 text-center">
      <h4>Dibujos</h4>
    </div>
    <div class="col-md-8 mt-3 px-md-5">
      <b>1.</b> En una hoja de maquina dibuja una persona “entera”. Puede ser cualquier tipo de persona que quieras dibujar, siempre que sea una persona completa, y no una caricatura o una figura hecha con palos.
    </div>
    <div class="col-md-8 px-md-5">
      <b>2.</b> Posteriormente, en otra hoja de maquina dibuja otra persona, del sexo contrario del primer dibujo.
      Cuando termines, al reverso de la hoja del segundo dibujo, escribe una historia donde estén incluidos los personajes de los dibujos que hiciste.
    </div>
    <div class="col-md-8 px-md-5">
      <b>3.</b> Cuando los termines le tomas una foto con un celular, a los dos dibujos y a la historia, (serian tres fotos en total) y los insertas en la parte de enviar archivo, y los envías.
      Gracias
    </div>
    <div class="col-12 mt-5">
      <div v-bind:class="loading">
        <div class="d-flex justify-content-center">
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div v-bind:class="result" class="mb-5 pb-5">
        <div class="row">
          <div class="col-md-4 pt-3 px-3 text-center">
            <div v-bind:class="loading_dibujo_1" class="row">
              <div class="col-12 text-center">
                Enviando...
              </div>
              <div class="d-flex justify-content-center text-center">
                <div class="spinner-border m-5 text-center" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-bind:class="result_dibujo_1">
              <div class="col-12 text-center" id="dibujo1"></div>
              <div class="form-group col-12" v-if="dibujo1.length==0">
                <label class="mb-3" for="file_dibujo1">Selecciona la foto del dibujo 1</label>
                <input 
                  type="file" 
                  v-on:change="Cambio_Imagen('dibujo1')" 
                  class="form-control-file" 
                  accept="image/*"
                  id="file_dibujo1">
              </div>
              <div class="col-12 mt-5 text-center" v-if="dibujo1.length>0">
                <button
                  v-if="!tiene_dibujo1"
                  class="btn btn-success" 
                  v-on:click="Guardar_Dibujo('dibujo1')">Guardar Dibujo 1</button>
              </div>
            </div>
          </div>
          <div class="col-md-4 pt-3 px-3 text-center">
            <div v-bind:class="loading_dibujo_2" class="row">
              <div class="col-12 text-center">
                Enviando...
              </div>
              <div class="d-flex justify-content-center text-center">
                <div class="spinner-border m-5 text-center" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-bind:class="result_dibujo_2">
              <div class="col-12 text-center" id="dibujo2"></div>
              <div class="form-group col-12" v-if="dibujo2.length==0">
                <label  class="mb-3" for="file_dibujo2">Selecciona la foto del dibujo 2</label>
                <input 
                  type="file" 
                  v-on:change="Cambio_Imagen('dibujo2')" 
                  class="form-control-file" 
                  accept="image/*"
                  id="file_dibujo2">
              </div>
              <div class="col-12 mt-5 text-center" v-if="dibujo2.length>0">
                <button v-if="!tiene_dibujo2" class="btn btn-success" v-on:click="Guardar_Dibujo('dibujo2')">Guardar Dibujo 2</button>
              </div>
            </div>
          </div>
          <div class="col-md-4 pt-3 px-3 text-center">
            <div v-bind:class="loading_dibujo_3" class="text-center row">
              <div class="col-12 text-center">
                Enviando...
              </div>
              <div class="d-flex justify-content-center text-center">
                <div class="spinner-border m-5 text-center" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-bind:class="result_dibujo_3">
              <div class="col-12 text-center" id="dibujo3"></div>
              <div class="form-group col-12" v-if="dibujo3.length==0">
                <label  class="mb-3" for="file_dibujo3">Selecciona la foto del dibujo 3</label>
                <input 
                  type="file" 
                  v-on:change="Cambio_Imagen('dibujo3')" 
                  class="form-control-file" 
                  accept="image/*"
                  id="file_dibujo3">
              </div>
              <div 
                class="col-12 mt-5 text-center" 
                v-if="dibujo3.length>0">
                <button v-if="!tiene_dibujo3" class="btn btn-success" v-on:click="Guardar_Dibujo('dibujo3')">Guardar Historia</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'',
      loading_dibujo_1:'d-none',
      loading_dibujo_2:'d-none',
      loading_dibujo_3:'d-none',
      result_dibujo_1:'',
      result_dibujo_2:'',
      result_dibujo_3:'',
      result:'',
      tiene_dibujo1:false,
      tiene_dibujo2:false,
      tiene_dibujo3:false,
      dibujo1:"",
      dibujo2:"",
      dibujo3:""
    }
  },
  methods:{
    Validar(dibujo){
      var pasar = true;
      switch(dibujo){
        case 'dibujo1':
          if (this.dibujo1.length==0) {
            swal('Dibujo 1 Obligatorio','Debes agregar la imagen del dibujo 1','error');
            pasar =false;
          }
        break;
        case 'dibujo2':
          if (this.dibujo2.length==0) {
            swal('Dibujo 2 Obligatorio','Debes agregar la imagen del dibujo 2','error');
            pasar =false;
          }
        break;
        case 'dibujo3':
          if (this.dibujo3.length==0) {
            swal('Dibujo 3 Obligatorio','Debes agregar la imagen del dibujo 3','error');
            pasar =false;
          }
        break;
      }
      return pasar;
    },
    Guardar_Dibujo(dibujo){
      if(!this.Validar(dibujo)){return;}
      this.Cargando(dibujo);
      switch(dibujo){
        case 'dibujo1':
          var dibujo_enviar=this.dibujo1;
        break;
        case 'dibujo2':
          var dibujo_enviar=this.dibujo2;
        break;
        case 'dibujo3':
          var dibujo_enviar=this.dibujo3;
        break;
      }
      this.$http.post('solicitudes/dibujos/subir',{
        campo:dibujo,
        imagen:dibujo_enviar,
        tiempo_restante:this.tiempo_restante
      })
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        this.Listo(dibujo);
        if (respuestaJson.resp=='Excelente') {
          this.Consultar_Dibujos();
          swal("Excelente",'Dibujo Agregado', "success");  
          if (this.dibujo3.length>0 && this.dibujo2.length>0 &&  this.dibujo1.length>0) {
            this.$router.push({name:'Examenes'});
          }
        }else{
          swal("¡Ups!",respuestaJson.resp, "error");  
        }
      })
      .catch(error=>{
        this.Listo(dibujo);
        swal("Favor de Intentar mas tarde", "Problemas para enviar el dibujo", "error");
      });
    },
    Consultar_Dibujos(){
      this.Cargando();
      this.$http.get('solicitudes/dibujos/consultar')
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        this.Listo();
        if (respuestaJson.resp=='Excelente') {
          this.dibujo1=respuestaJson.dibujo1;
          this.dibujo2=respuestaJson.dibujo2;
          this.dibujo3=respuestaJson.dibujo3;
          if (this.dibujo1.length>0) {
            var imagen1 = $('<img style="max-height:300px;max-width:200px;" src="'+this.dibujo1+'" alt="" class="mx-auto text-center">');
            $('#dibujo1').empty().append(imagen1);
            this.tiene_dibujo1=true;
          }
          if (this.dibujo2.length>0) {
            var imagen2 = $('<img style="max-height:300px;max-width:200px;" src="'+this.dibujo2+'" alt="" class="mx-auto text-center">');
            $('#dibujo2').empty().append(imagen2);
            this.tiene_dibujo2=true;
          }
          if (this.dibujo3.length>0) {
            var imagen3 = $('<img style="max-height:300px;max-width:200px;" src="'+this.dibujo3+'" alt="" class="mx-auto text-center">');
            $('#dibujo3').empty().append(imagen3);
            this.tiene_dibujo3=true;
          }
        }else{
          swal("¡Ups!",respuestaJson.resp, "error");  
        }
      })
      .catch(error=>{
        this.Listo();
        swal("Favor de Intentar mas tarde", "Problemas para consultar los dibujos", "error");
      });
    },
    Cambio_Imagen(dibujo){
      var that = this;
      switch(dibujo){
        case 'dibujo1':
          var file = document.querySelector('#file_dibujo1')['files'][0];
        break;
        case 'dibujo2':
          var file = document.querySelector('#file_dibujo2')['files'][0];
        break;
        case 'dibujo3':
          var file = document.querySelector('#file_dibujo3')['files'][0];
        break;
      }
      if (file!=null) {
        var reader = new FileReader();
        var baseString;
        reader.onloadend = function () {
          baseString = reader.result;
          var imagen = $('<img style="max-height:300px;max-width:200px;" src="'+baseString+'" alt="" class="mx-auto img-fluid text-center">');
          switch(dibujo){
            case 'dibujo1':
              that.dibujo1=baseString;
              $('#dibujo1').empty().append(imagen);
            break;
            case 'dibujo2':
              that.dibujo2=baseString;
              $('#dibujo2').empty().append(imagen);
            break;
            case 'dibujo3':
              that.dibujo3=baseString;
              $('#dibujo3').empty().append(imagen);
            break;
          }
        };
        reader.readAsDataURL(file); 
      }
    },
    Cargando(dibujo){
      console.log(dibujo);
      if (dibujo==undefined) {
        this.result='d-none';
        this.loading='';
      }else{
        switch(dibujo){
          case 'dibujo1':
            this.result_dibujo_1='d-none';
            this.loading_dibujo_1='';
          break;
          case 'dibujo2':
            this.result_dibujo_2='d-none';
            this.loading_dibujo_2='';
          break;
          case 'dibujo3':
            this.result_dibujo_3='d-none';
            this.loading_dibujo_3='';
          break;
        }

      }
    },
    Listo(dibujo){
      console.log(dibujo);
      if (dibujo==undefined) {
        this.result='';
        this.loading='d-none';
      }else{
        switch(dibujo){
          case 'dibujo1':
            this.result_dibujo_1='';
            this.loading_dibujo_1='d-none';
          break;
          case 'dibujo2':
            this.result_dibujo_2='';
            this.loading_dibujo_2='d-none';
          break;
          case 'dibujo3':
            this.result_dibujo_3='';
            this.loading_dibujo_3='d-none';
          break;
        }
      }
    },
  },
  computed:{
    mostrar_tiempo_restante(){
      return this.$store.getters.getMostrar_Tiempo_Restante;
    },
    avance_total(){
      return this.$store.getters.getAvance_Total;
    },
    tiempo_restante(){
      return this.$store.getters.getTiempo_Restante;
    },
    tiempo_restante_horas(){
      return this.$store.getters.getTiempo_Restante_Horas;
    }
  },
  mounted(){
    this.Consultar_Dibujos();
  }
};
</script>

<style scoped>
img {
  max-height: 200px;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Dibujos/Dibujos.vue